import { createNextTableContext } from '@core/table';

export const CashFlowTransactionsTableContext = createNextTableContext();
